
import { CardContent as MuiCardContent, Card as MuiCard, Typography, Box, Fade } from "@material-ui/core";
import styled from "styled-components/macro";
import LineChart from "./components/LineChart";
import { FC } from "react";
import NoDataAvailable from "./components/NoDataAvailable";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)`
        position: relative;
        border-radius: 14px
    `;

const CardContent = styled(MuiCardContent)`
        padding: 0;
    `;

type PropsType = {
  data: {
    [key: string]: number
  },
}

const VisitorsAccessibilityWidget:FC<PropsType> = ({data}) => {
  const { t } = useTranslation();
  const haveData = data && Object.keys(data).length > 0
  return (
    <Fade in={true}>
      <Card>
        <CardContent>
          <Box m={4}>
            <Typography>
              {t("statsPage_visitorsThatOpened")}
            </Typography>
          </Box>
          <Loading loading={!data} height={236}>
            <Box>
              <Box ml={3} mr={4} mb={1}>
                <LineChart data={data}/>
              </Box>
              <NoDataAvailable visible={!haveData}/>
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}
export default VisitorsAccessibilityWidget
